module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('div', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre3"
  }, [_c('br', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "title": "Dedication"
    }
  }, [_c('br', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_c('br', {
    staticClass: "calibre3"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "blcc-book-pages"
  }, [_c('span', {
    staticClass: "charoverride4"
  }, [_vm._v("To"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Lieutenant A. P. Davies R.H.A."), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("and"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Captain D. S. Graham M.C., R.A.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae521fd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Dedication.vue
// module id = 72
// module chunks = 0